import React from "react";
import {Link} from "react-router-dom";
import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';

class StdButton extends React.Component {

    constructor(props) {
        super(props);

        this.renderIcon = this.renderIcon.bind(this);
    }

    render() {

        if (this.props.type == "alt") {
            var style = {
                fontFamily: 'Open Sans',
                letterSpacing: '1.25px',
                color: 'rgba(0,0,0,0.38)',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                marginLeft: 10,
                '&:hover': {
                    backgroundColor: 'transparent',
                }
            };
        } else {
            var style = {
                fontFamily: 'Open Sans',
                letterSpacing: '1.25px',
                color: '#C1272D',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                marginLeft: 10,
                '&:hover': {
                    backgroundColor: 'transparent',
                }
            };
        }

        if (this.props.link) {
            return (
                <Button style={style} component={Link} to={this.props.link}>
                    {this.renderIcon()}
                    <span>
                        {this.props.label}
                    </span>
                </Button>
            )
        } else {
            return (
                <Button style={style} onClick={this.props.onClick}>
                    {this.renderIcon()}
                    <span>
                        {this.props.label}
                    </span>
                </Button>
            )
        }
    }

    renderIcon() {
        if (this.props.icon) {
            if (this.props.icon == 'create') {
                return (
                    <SvgIcon style={{marginRight: '5px'}}>
                        <path fill="none" d="M0 0h24v24H0V0z"/>
                        <path
                            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z"/>
                    </SvgIcon>
                );
            } else if (this.props.icon == 'delete') {
                return (
                    <SvgIcon style={{marginRight: '5px'}}>
                        <path fill="none" d="M0 0h24v24H0V0z"/>
                        <path
                            d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"/>
                    </SvgIcon>
                );
            } else if (this.props.icon == 'person') {
                return (
                    <SvgIcon style={{marginRight: '5px'}}>
                        <path fill="none" d="M0 0h24v24H0V0z"/>
                        <path
                            d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </SvgIcon>
                );
            } else if (this.props.icon == 'person_add') {
                return (
                    <SvgIcon style={{marginRight: '5px'}}>
                        <path fill="none" d="M0 0h24v24H0V0z"/>
                        <path
                            d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z"/>
                    </SvgIcon>
                );
            } else if (this.props.icon == 'cloud_upload') {
                return (
                    <SvgIcon style={{marginRight: '5px'}}>
                        <path fill="none" d="M0 0h24v24H0V0z"/>
                        <path
                            d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"/>
                    </SvgIcon>
                );
            } else {
                return (
                    <i className="material-icons">
                        {this.props.icon}
                    </i>
                );
            }
        }
    }
}

export default StdButton;